import {
    IS_LOADING, NOTIFICATION_SEND_MSG_SUCCESS,NOTIFICATION_SEND_MSG_ERROR,NOTIFICATION_LIST_SUCCESS,NOTIFICATION_LIST_ERROR } from "../actions/Type";

const initialState = {
    send_msg: {},
    notify_list: {},
    loading: false,
};

export const NotifyReducers = (
    state = initialState,
    { type, payload } = {},
) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case NOTIFICATION_SEND_MSG_SUCCESS:
            return {
                ...state,
                send_msg: payload,
                loading: false,
            };
        case NOTIFICATION_SEND_MSG_ERROR:
            return {
                ...state,
                send_msg: payload,
                loading: false,
            };
        case NOTIFICATION_LIST_SUCCESS:
            return {
                ...state,
                notify_list: payload,
                loading: false,
            };
        case NOTIFICATION_LIST_ERROR:
            return {
                ...state,
                notify_list: payload,
                loading: false,
            };

        default:
            return state;
    }
};